import { LegalPage } from '../components/landing/LegalPage';
import { refundPolicy } from '../legal/documents';

export function Refunds() {
  return <LegalPage source={refundPolicy} />;
}
